import NoSnippets from './NoSnippets'

export default NoSnippets
